import React from 'react';

const UpiPaymentIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_12019_273"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_12019_273)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2876 16.2032L18.162 4L11.3557 28L24.2876 16.2032Z"
        fill="#097939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9311 16.2032L13.8063 4L7 28L19.9311 16.2032Z"
        fill="#ED752E"
      />
    </g>
  </svg>
);

export default UpiPaymentIcon;
